module.exports = __webpack_public_path__ + "img/0.84906121.webp";